import { Endpoint } from '../endpoint';
import { TaskSectionResponse, TaskStepResponse, TaskSectionId, TaskStepId } from '@business/entities/task';
import { TaskId } from '@business/entities/task';

export function fetchTaskSections(taskId: TaskId) {
  return Endpoint.get<TaskSectionResponse[]>(`@gc/task-section/${taskId}`);
}

export function createSection(taskId: TaskId, data: { name: string; isPublic?: boolean }) {
  return Endpoint.post<TaskSectionResponse>(`@gc/task-section/section/${taskId}`, { data });
}

export function updateSection(sectionId: TaskSectionId, data: { name: string; isPublic?: boolean }) {
  return Endpoint.patch<TaskSectionResponse>(`@gc/task-section/section/${sectionId}`, { data });
}

export function deleteSection(sectionId: TaskSectionId) {
  return Endpoint.delete<void>(`@gc/task-section/section/${sectionId}`);
}

export function createStep(sectionId: TaskSectionId, data: { name: string; link?: string; instructions?: string; parentId?: TaskStepId }) {
  return Endpoint.post<TaskStepResponse>(`@gc/task-section/step/${sectionId}`, { data });
}

export function updateStep(stepId: TaskStepId, data: { name: string; link?: string; instructions?: string }) {
  return Endpoint.patch<TaskStepResponse>(`@gc/task-section/step/${stepId}`, { data });
}

export function deleteStep(stepId: TaskStepId) {
  return Endpoint.delete<void>(`@gc/task-section/step/${stepId}`);
}

export function toggleStep(stepId: TaskStepId) {
  return Endpoint.post<TaskStepResponse>(`@gc/task-section/toggle/${stepId}`, {});
}

export function sortSections(taskId: TaskId, ids: TaskSectionId[]) {
  return Endpoint.post<void>(`@gc/task-section/sort-section/${taskId}`, { data: { ids } });
}

export function sortSteps(sectionId: TaskSectionId, ids: TaskStepId[]) {
  return Endpoint.post<void>(`@gc/task-section/sort-step/${sectionId}`, { data: { ids } });
}
